import React, { useState } from 'react';

//Components
import ComposeInscriptionFormComponent from 'app/tournaments/components/compose-inscription-form/ComposeInscriptionFormComponent'
import PrimaryButtonComponent from 'shared/components/primary-button/PrimaryButtonComponent';
import SecondaryButtonComponent from 'shared/components/secondary-button/SecondaryButtonComponent';

// Styles
import './PaymentsFormActiveComponent.styles.css';

//i18
import { withTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

function PaymentsFormActiveComponent(props) {
    
    const FORM_TEMPLATE_SECTIONS = props.inscription_form_template;

    const [submitButton, setSubmitButton] = useState(false);
    const [ step1, setStep1 ] = useState(true);
    const [ step2, setStep2 ] = useState(false);
    const [ step3, setStep3 ] = useState(false);
    const [ step4, setStep4 ] = useState(false);
    const [ step5, setStep5 ] = useState(false);
    const [ steper2, setSteper2 ] = useState(false);
    const [ steper3, setSteper3 ] = useState(false);
    const [ steper4, setSteper4 ] = useState(false);
    const [ steper5, setSteper5 ] = useState(false);
    const [ valueStep, setValueStep ] = useState(0);
    const [ formAnswers, setformAnswers]= useState([]);  // eslint-disable-line
    const [ lastStep, setLastStep] = useState(0);

    const [ completedForms, setCompletedForms] = useState([]); // eslint-disable-line
    const [ fulfilledForm, setFulfilledForm ] = useState(false);
    const [ formIndex, setFormIndex ] = useState(0);   // eslint-disable-line  
    const [ submitForm, setSubmitForm ] = useState(true);

    const handleSendFormData = (form_index) => {
        if(form_index ===  (lastStep -1) && submitForm) {
            if(props.inscription_form_template.form_type.caption === "account_company_form") {
                props.handleSendFormData(formAnswers);
            } else {
                props.handleSendFormData(formAnswers);
            }            
        }
        setSubmitForm(true);
    }

    
    
    const handleNextButton=(value, step, form_index) => {
        props.handleCleanCountryForm();
        setFormIndex(form_index); 
        setFulfilledForm(false);

        handleCompletedForms(validationJsonAnswers(value), form_index);

        if(formAnswers[form_index + 1] || form_index === (lastStep -1)) {
            setFulfilledForm(true);
            let is_country = undefined;
            if(form_index === (lastStep -1)){
                is_country = completedForms[form_index].questions.find( question => question.question_type.caption === 'country');
            }else{
                is_country = completedForms[form_index + 1].questions.find( question => question.question_type.caption === 'country');
            }
            if(is_country) {
                props.handleSearchNationality(is_country.value)
            }
        }  
        
        //Se valida que sea el ultimo formulario con informacion para validar si se envia al backend
        if(!formAnswers[form_index + 1]) {
            handleSendFormData(form_index);
        }
        switch(step) {
            case 'step1':
                setStep1(false);
                setStep2(true);
                setSteper2(true);
                setSubmitButton(false);
                setValueStep(2)
                break;
            case 'step2':
                setStep2(false);
                setStep3(true);
                setSteper3(true);
                setSubmitButton(false);
                setValueStep(3)
                break;
            case 'step3':
                setStep3(false);
                setStep4(true);
                setSteper4(true);
                setSubmitButton(false);
                setValueStep(4)
                break;
            case 'step4':
                if(props.inscription_form_template.form_type.caption === "account_company_form" ){
                    setStep4(false);
                    setStep5(true);
                    setSteper5(true);
                    setSubmitButton(false);
                    setValueStep(5)
                }
                break;
            default:
                return ''
        }
        
    };
    
    const validationJsonAnswers = (value) =>{
        let json_answer=[];
        let newJsonAnswer= {};
        let form_question_template = ''

        if(value.form_template_is_json){
            value.questions.forEach((answer) => {
                form_question_template = answer.form_question_template.split('_key_')[0]
                const answer_key = answer.form_question_template.split('_key_')[1];
                const answer_value = answer.text_answer;
                newJsonAnswer[`${answer_key}`] = answer_value;
            });
            json_answer.push(newJsonAnswer);
        };

        return value.form_template_is_json 
        ?  {...value, 
            questions:[{
                json_answer:json_answer,
                form_question_template:form_question_template,
                text_answer: '',
                file_document: null,
                date_field: null,
                boolean_answer: null,
                answers: []
            }]
        } 
        : value;
    }

    const handleBackStep=(value) =>{
        // let backStep = null;

        if(value){
            //ultimo paso hacia atras bloquea envio de form
            setSubmitForm(false);
        }

        setTimeout(()=>{
            setFulfilledForm(true);
            const backStep = (valueStep-1)
            let is_country = completedForms[backStep - 1].questions.find( question => question.question_type.caption === 'country');
            if(is_country) {
                props.handleCleanCountryForm();
                props.handleSearchNationality(is_country.value)
            }
            if(backStep === 1){
                setStep1(true);
                setStep2(false);
                setSteper2(false);
                //console.log(setformAnswers(value))
                setValueStep(1)
            }else if(backStep === 2){
                setStep2(true);
                setStep3(false);
                setSteper3(false);
                setValueStep(2)
            }else if(backStep === 3){
                setStep3(true);
                setStep4(false);
                setSteper4(false);
                setValueStep(3)
            }else if(backStep === 4 && steper5){
                setStep4(true);
                setStep5(false);
                setSteper5(false);
                //setformAnswers(value);
                setValueStep(4)
            }
        }, 500);
        
    }

    function handleCompletedForms (form_values, form_index) { 
        let questions = [];
        let form_answers = [];
        form_values.questions.forEach( (form_answer, index) => {
            let new_answer_full = FORM_TEMPLATE_SECTIONS.sections[form_index].questions.find( question => question.id === form_answer.form_question_template);

            let new_answer = cloneDeep(new_answer_full);

            if(new_answer) {
                if(typeof(form_answer.text_answer) === 'string') {
                    new_answer.value = form_answer.text_answer;
                }
                if(form_answer.date_field !== null) {
                    new_answer.value = form_answer.date_field;
                }
                if(form_answer.json_answer) {
                    new_answer['json_answer'] = form_answer.json_answer;
                }
                if(form_answer.file_document){
                    new_answer.value = form_answer.file_document
                }
                if(!form_answer.date_field && !form_answer.boolean_answer && !form_answer.file_document && form_answer.text_answer === ""){
                    let checked_answ = form_answer.answers?.filter(answ => answ.is_checked === true);
                    new_answer.answers.map(ansrs =>{ // eslint-disable-line  
                        let selected =  checked_answ.find(chkans => chkans.id === ansrs.id);
                        if(selected){
                            ansrs.is_default = true
                        }else{
                            ansrs.is_default = false
                        }
                    });
                }
                questions.push(new_answer);
                form_answers.push(form_answer);
            } else if(form_answer.form_question_template.includes('_country')) {
                let country_question = FORM_TEMPLATE_SECTIONS.sections[form_index].questions.find(question => question.question_type.caption === 'country_state');
                let new_question = cloneDeep(country_question);
                new_question.id = `${country_question.id}_country`;
                new_question.question_type.caption = 'country';
                new_question.value = form_answer.text_answer;
                questions.push(new_question);
            }            
        })

        completedForms.splice(form_index, 1, {id:  FORM_TEMPLATE_SECTIONS.sections[form_index].id, questions: questions})
        formAnswers.splice(form_index, 1, form_answers)
    }

    function handleFormFulfilledStatus (index_form)  {   
           
        if(fulfilledForm ) {
            return completedForms[index_form];
        } else {
            return FORM_TEMPLATE_SECTIONS.sections[index_form];
        }
    }

    return (
        <div className="payment-forms_parent">
            <div className="payment-forms_parent__stepper">
                <div className='step-point__container'>
                    <div className={ "step-point" }>
                        <div className='baloa-username step-point-label-completed'>{props.inscription_form_template.form_type.caption === "account_company_form" ?props.t("dataDetails"):props.t("dataPersonal")}</div>
                        <div className='point step-point-completed' />
                    </div>
                        <div className={ "step-point" }>
                        <div className={`baloa-username ${steper2? 'step-point-label-completed': ''}`}>{props.inscription_form_template.form_type.caption === "account_company_form" ?props.t("dataRepresentative"):props.t("dataCompany")}</div>
                        <div className={`point ${steper2? 'step-point-completed': ''}`} />
                    </div>
                    <div className={ "step-point" }>
                        <div className={`baloa-username ${steper3? 'step-point-label-completed': ''}`}>{props.inscription_form_template.form_type.caption === "account_company_form" ?props.t("dataOwner"):props.t("dataPublic")}</div>
                        <div className={`point ${steper3? 'step-point-completed': ''}`} />
                    </div>
                    <div className={ "step-point" }>
                        <div className={`baloa-username ${steper4? 'step-point-label-completed': ''}`}>{props.inscription_form_template.form_type.caption === "account_company_form" ?props.t("dataPublic"):props.t("bankAccounts")}</div>
                        <div className={`point ${steper4? 'step-point-completed': ''}`} />
                    </div>
                    { props.inscription_form_template.form_type.caption === "account_company_form" &&
                        <div className={ "step-point" }>
                        <div className={`baloa-username ${steper5? 'step-point-label-completed': ''}`}>{props.t("bankAccounts")}</div>
                        <div className={`point ${steper5? 'step-point-completed': ''}`} />
                        </div>}
                </div>
                <div className='payments__step-line__container'>
                    <div className={ `step-line ${ steper2? 'step-line-completed': ''}` } />
                    <div className={ `step-line ${ steper3? 'step-line-completed': ''}` } />
                    <div className={ `step-line ${ steper4? 'step-line-completed': ''}` } />
                    <div className={ `step-line ${ steper5? 'step-line-completed': ''}` } />
                </div>
            </div>

            { step1 &&
                //console.log( funcion(answers [] = form_templete otro))
                <ComposeInscriptionFormComponent
                    inscription_form_template={ handleFormFulfilledStatus(0) }
                    onNewData = { (value)=>{handleNextButton(value,'step1', 0)}}
                    submitForm={submitButton}
                    resetButton={()=>{setSubmitButton(false)}}
                    countries={props.countries}
                    country_states={props.country_states}
                    handleSearchNationality={ props.handleSearchNationality }
                    gateway_attribute={props.gateway_attribute}
                    handleSearchCountryStates={props.handleSearchCountryStates}
                    fulfilled_form={fulfilledForm}
                /> 
            } 
            { step2 &&
                <ComposeInscriptionFormComponent
                    inscription_form_template={ handleFormFulfilledStatus(1) }
                    onNewData = { (value)=>{handleNextButton(value,'step2', 1)}}
                    submitForm={submitButton}
                    resetButton={()=>{setSubmitButton(false)}}
                    countries={props.countries}
                    country_states={props.country_states}
                    handleSearchNationality={ props.handleSearchNationality }
                    gateway_attribute={props.gateway_attribute}
                    handleSearchCountryStates={props.handleSearchCountryStates}
                    fulfilled_form={fulfilledForm}
                />                     
            } 
            { step3 &&
                <ComposeInscriptionFormComponent
                    inscription_form_template={ handleFormFulfilledStatus(2) }
                    onNewData = { (value)=>{handleNextButton(value,'step3', 2)}}
                    submitForm={submitButton}
                    resetButton={()=>{setSubmitButton(false)}}
                    countries={props.countries}
                    country_states={props.country_states}
                    handleSearchNationality={ props.handleSearchNationality }
                    gateway_attribute={props.gateway_attribute}
                    handleSearchCountryStates={props.handleSearchCountryStates}
                    fulfilled_form={fulfilledForm}
                />  
            } 
            { step4 &&
                <ComposeInscriptionFormComponent
                    inscription_form_template={ handleFormFulfilledStatus(3) }
                    onNewData = {(value)=>{handleNextButton(value,'step4', 3)}}
                    submitForm={submitButton}
                    resetButton={()=>{setSubmitButton(false)}}
                    countries={props.countries}
                    country_states={props.country_states}
                    handleSearchNationality={ props.handleSearchNationality }
                    gateway_attribute={props.gateway_attribute}
                    handleSearchCountryStates={props.handleSearchCountryStates}
                    fulfilled_form={fulfilledForm}
                />    
            }
            { step5 && props.inscription_form_template.form_type.caption === "account_company_form" &&
                <ComposeInscriptionFormComponent
                    inscription_form_template={ handleFormFulfilledStatus(4) }
                    onNewData = {(value)=>{handleNextButton(value,'step5', 4)}}
                    submitForm={submitButton}
                    resetButton={()=>{setSubmitButton(false)}}
                    countries={props.countries}
                    country_states={props.country_states}
                    handleSearchNationality={ props.handleSearchNationality }
                    gateway_attribute={props.gateway_attribute}
                    handleSearchCountryStates={props.handleSearchCountryStates}
                    fulfilled_form={fulfilledForm}
                />    
            }

            {/*Botones*/}
            
            {/* { props.inscription_form_template.form_type.caption === "account_company_form" && !steper5 && */}
                <div className='payment-forms-active__step'> 
                    <div className='payment-forms_parent__buttons'>
                        { !step1 &&
                            <SecondaryButtonComponent
                            type="button"
                            id="payment-data__back-btn"
                            onClick={ () => {
                                handleBackStep((lastStep === 5)? step5 : step4);
                                ((lastStep === 4) && step4) && setSubmitButton(true);
                                ((lastStep === 5) && step5) && setSubmitButton(true);   
                            } } 
                            disabled={false}
                            >
                                <span>{props.t('paymentButtons.backButton')}</span>
                            </SecondaryButtonComponent>
                        }
                        <PrimaryButtonComponent
                            type={'button'}
                            onClick={ ()=>{
                                /* if(props.inscription_form_template.form_type.caption === "account_company_form" ){
                                    setLastStep(4)
                                    // if(steper5)
                                    // {props.handleFinalizePayments()}
                                }else{
                                    setLastStep(3)
                                    // if(steper4)
                                    // {props.handleFinalizePayments()}
                                } */
                                setLastStep(props.inscription_form_template?.sections?.length);
                                setSubmitButton(true)
                            }}
                            disabled={props.onboarding_form_payment_loading} 
                            className='small'
                        >
                            
                            { (props.inscription_form_template.form_type.caption === "account_company_form" && !steper5) ||
                                (props.inscription_form_template.form_type.caption === "account_individual_form" && !steper4)  
                                ?<span>{props.t('buttomNext')}</span>
                                :props.onboarding_form_payment_loading
                                    ?<span className='payment-forms__onboarding-submit-form' />
                                    :<span>{props.t('buttonFinalize')}</span>
                                
                            }
                                    
                        </PrimaryButtonComponent>    
                    </div>
                </div>
            
        </div>
        // }
    )
}

export default withTranslation('payments')(PaymentsFormActiveComponent)